import React, { useCallback } from 'react';
import { Card } from '@mui/material';
import { useModal } from '@europrocurement/flexy-components/providers';

import {
    InformationCard,
    InformationCardItemProps,
    OptionsType,
} from '@europrocurement/flexy-components';
import { UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';

import { type User } from '../../../types/type';
import { UserForm, UserFormProps } from '../UserForm/UserForm';
import { UserAccess } from '../UserAccess/UserAccess';

export type UserInfosProps = {
    user: User;
    poles: OptionsType;
    services: OptionsType;
    groupes: OptionsType;
    antennes: OptionsType;
    handlePatchInfos: UserFormProps['handlePatchInfos'];
    handleValidationModal: (
        payload: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur,
        field: string,
        value: boolean,
    ) => void;
};

export const UserInfos: React.FunctionComponent<UserInfosProps> = function ({
    user,
    services,
    poles,
    groupes,
    antennes,
    handlePatchInfos,
    handleValidationModal,
}) {
    /**
     * List all the user contact informations
     */
    const contactInfos: Array<InformationCardItemProps> = [
        { label: 'Prénom', value: user.prenom },
        { label: 'Nom', value: user.nom },
        { label: 'Initiales', value: user.initiales },
        { label: 'Login', value: user.user },
        { label: 'Identifiant Keycloak', value: user.userIdentifier },
        { label: 'Mail', value: user.mail },
        { label: 'Ligne directe', value: user.ligneDirecte },
        { label: 'Portable', value: user.portable },
        { label: 'Poste interne', value: user.poste },
        { label: 'Fonction', value: user.fonction },
        { label: 'Antenne', value: user.antenne?.libelle },
        { label: 'Pole', value: user.pole?.libelle },
        { label: 'Service', value: user.service?.libelle },
        { label: 'Groupe', value: user.idGroupeGie?.groupName },
        { label: 'Libellé Société', value: user.libelleSociete },
        { label: 'Libellé Société employeur', value: user.libelleSocieteEmployeur },
    ];

    // form default values (initial values from the API)

    const { modalActions } = useModal();

    const modifyUser = useCallback(() => {
        modalActions.call(
            <UserForm
                user={user}
                antennes={antennes}
                services={services}
                poles={poles}
                groupes={groupes}
                handlePatchInfos={handlePatchInfos}
            />,
        );
    }, [antennes, groupes, handlePatchInfos, modalActions, poles, services, user]);

    return (
        <>
            <UserAccess
                user={user}
                handleValidationModal={handleValidationModal}
            />
            <Card
                data-testid="info-card"
                sx={{ width: '100%', margin: '10px 0 0 0', padding: '0' }}
            >
                <InformationCard
                    title="Informations utilisateur"
                    button={{
                        label: 'Modifier',
                        onClick: modifyUser,
                    }}
                    items={contactInfos}
                    subtitle=""
                />
            </Card>
        </>
    );
};
